import PanelUserParameters from "./panelUserParameters"

const TabUserParameters = () => <PanelUserParameters/>

export default TabUserParameters
